/**
 * @description
 * Objeto fieldtypes
 */

export class Fieldtypes {
    public id:number = null;
    public code:string = "";
    public desc:string;
    public url:string;
    public typefld:number = null;
    public precision:number = null;
    public unit:string;
    public separator:string;
    public delimiter:string;
    public roundvalue:boolean = false;
    public formatout:string;
    public formatoutes:string;
    public align:string;
    public format:number = null;
  
    constructor() {}
  
}